<div class="paybee-modal-header">
    <div class="row">
        <div class="col-11">
            <div class="modal-main-heading">Street Address</div>
        </div>
        <div class="col-1">
            <button (click)="close('close')" type="button" class="close">
                <span aria-hidden="true" class="black-text">&times;</span>
            </button>
        </div>    
    </div>
    @if(data){
        <div class="row">
            <div class="col">
                <div class="modal-sub-heading">{{data.streetAddressReason}}</div>
            </div>
        </div>
    }
</div>
<div class="modal-body custom-material-form updated-dropdown" [formGroup]="streetAddressForm">
    <div class="row">
        <div class="col-12">
            <mdb-form-control class="form-fill">
                <app-mdbp-input mdbInput formControlName="street" maxLength="128" label='Enter Street Address'></app-mdbp-input>
                @if(streetAddressForm.controls.street.hasError('required') && streetAddressForm.controls.street.touched) {
                    <span class="form-fill-error">Street Address is required</span>
                }
            </mdb-form-control>
            
            <mdb-form-control class="form-fill">
                <app-mdbp-input mdbInput formControlName="unit" maxLength="128" label='Unit# (optional)'></app-mdbp-input>
            </mdb-form-control>

            <mdb-form-control class="form-fill">
                <app-mdbp-input mdbInput formControlName="city" maxLength="128" label='City'></app-mdbp-input>
                @if(streetAddressForm.controls.city.hasError('required') && streetAddressForm.controls.city.touched) {
                    <span class="form-fill-error">City is required</span>
                }
            </mdb-form-control>

            <mdb-form-control class="form-fill">
                <app-mdbp-input mdbInput formControlName="zipCode" maxLength="6" label='Zip Code'></app-mdbp-input>
                @if(streetAddressForm.controls.zipCode.hasError('required') && streetAddressForm.controls.zipCode.touched) {
                    <span class="form-fill-error">Zip Code is required</span>
                }
            </mdb-form-control>

            <mdb-form-control class="form-fill">
                <mdb-select formControlName="stateSelect" class="mdb-select">
                    @for(option of states; track option.abbreviation) {
                        <mdb-option [value]="option.abbreviation">{{option.name}}</mdb-option>
                    }
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Select State</label>
                @if(streetAddressForm.controls.stateSelect.hasError('required') && streetAddressForm.controls.stateSelect.touched) {
                    <span class="form-fill-error">No Option Selected</span>
                }
            </mdb-form-control>
        </div>
    </div>
</div>
<div class="modal-footer paybee-modal-footer">
    <a (click)="close('close')" class="btn btn-sm modal-cancel-button">Cancel</a>
    <a (click)="onClickSelect()" class="btn btn-sm modal-confirm-button">Select</a>
</div>
